<template>
  <div>
    <ExamsModalAlert ref="examsModalAlert" />
    <card-form
      :collapsed="!isExamCollapsed"
      class="exam__container exam-item maternity-exam"
    >
      <div
        slot="expanded"
        class="form-container"
      >
        <md-layout md-flex="100">
          <h2 class="title-main form-title title-card">
            Editar exame
          </h2>
        </md-layout>
        <md-layout
          :md-gutter="24"
          md-flex="100"
        >
          <md-layout md-flex="15">
            <md-input-container
              id="patientIdLis"
              :class="{ 'md-input-invalid': errors.has('idExamCode') }"
            >
              <label>Código do Exame</label>
              <md-input
                id="txtNewExamCode"
                v-model="item.details.code"
                name="idExamCode"
                type="text"
                disabled
                placeholder="Código do Exame"
              />
            </md-input-container>
          </md-layout>
          <md-layout md-flex="35">
            <md-input-container
              id="patientName"
              :class="{ 'md-input-invalid': errors.has('examName') }"
            >
              <label>Nome do Exame</label>
              <md-input
                id="txtNewExamName"
                v-model="item.details.name"
                name="examName"
                type="text"
                disabled
                placeholder="Nome do Exame"
              />
            </md-input-container>
          </md-layout>
          <md-layout md-flex="20">
            <md-input-container
              id="examMaterial"
              class="md-advanced-select md-input-placeholder md-has-value"
              :class="{
                'md-input-invalid': errors.has('material')
              }"
            >
              <label>Material</label>
              <div class="advanced-select__container">
                <model-list-select
                  :id="'cboNewMaterial'"
                  v-model="material"
                  v-validate="'required'"
                  label="label"
                  placeholder="Selecione..."
                  :options="getAvailableMaterials()"
                  q
                  name="material"
                >
                  <span slot="no-options"><p class="v-select-no-matching">
                    Desculpe, não foram encontrados materiais para essa pesquisa.
                  </p></span>
                </model-list-select>
              </div>
              <span class="md-error">Obrigatório</span>
            </md-input-container>
          </md-layout>
          <md-layout md-flex="10">
            <md-input-container :class="{ 'md-input-invalid': errors.has('samples') }">
              <label class="dont-wrap">Qtd. Amostras</label>
              <md-input
                id="txtNewSampleQuantity"
                v-model="amount"
                v-validate="'required|min_value:1'"
                v-mask="'###'"
                name="samples"
                show-labels="false"
                maxlength="3"
                data-vv-validate-on="none"
                type="text"
                disabled
                placeholder="Amostras"
              />
              <span
                v-if="errors.firstByRule('samples', 'required')"
                class="md-error"
              >Obrigatório</span>
              <span
                v-else-if="errors.firstByRule('samples', 'min_value')"
                class="md-error"
              >Valor inválido</span>
            </md-input-container>
          </md-layout>
          <md-layout md-flex="15">
            <md-input-container
              id="conditioning"
              :class="{ 'md-input-invalid': errors.has('conditioning') }"
            >
              <label>Acondicionamento</label>
              <md-input
                id="txtNewConditioning"
                v-model="conditioning"
                name="conditioning"
                type="text"
                disabled
                value="Acondicionamento"
                placeholder="Acondicionamento"
              />
            </md-input-container>
          </md-layout>
          <md-layout md-flex="50">
            <md-input-container
              id="examCollector"
              :class="{ 'md-input-invalid': errors.has('examCollector') }"
            >
              <label>Coletador *</label>
              <md-input
                id="txtNewPatExamCollector"
                v-model="collector_name"
                v-validate="'required'"
                name="examCollector"
                type="text"
                maxlength="100"
                placeholder="Coletador *"
                data-vv-validate-on="none"
                @keydown.enter.native="focusNextField('txtNewPatExamJudge')"
              />
              <span class="md-error">Obrigatório</span>
            </md-input-container>
          </md-layout>
          <md-layout md-flex="50">
            <md-input-container id="examJudge">
              <label>Nome do juiz (somente em casos judiciais)</label>
              <md-input
                id="txtNewPatExamJudge"
                v-model="judge_name"
                name="examJudge"
                type="text"
                maxlength="100"
                placeholder="Nome do juiz (somente em casos judiciais)"
                @keydown.enter.native="focusNextField('txtNewAddExamNote')"
              />
            </md-input-container>
          </md-layout>
          <md-layout md-flex="50">
            <md-input-container id="examComments">
              <label>Observação</label>
              <div
                class="orders-new__observation-container"
                @keydown.enter.capture="preventRawEnterFromPropagation"
              >
                <md-textarea
                  id="txtNewAddExamNote"
                  v-model="notes"
                  v-validate=""
                  maxlength="250"
                  type="text"
                  name="exam.comments"
                  placeholder="Observação"
                  @keydown.enter.native="focusNextField('txtNewPatExamParticipants_' + index)"
                />
              </div>
            </md-input-container>
          </md-layout>
          <md-layout
            md-flex="50"
            class="exam-item__details"
          >
            <div class="exam-item__details-anchor">
              <md-icon
                md-src="/static/images/icon-info.svg"
                class="exam-item__details-icon"
              />
              <a
                id="txtNewExamDetails"
                tabindex="-1"
                :href="'/exames/detalhes?mnemonic=' + item.details.code"
                target="_blank"
                class="exam-item__details-anchor__text"
              >
                Detalhes do Exame
              </a>
            </div>
          </md-layout>
        </md-layout>

        <md-layout
          :md-gutter="24"
          md-flex="100"
        >
          <md-layout
            v-if="item.details.deadline?.trim()"
            md-flex="15"
          >
            <md-input-container id="deadline">
              <label>Prazo de execução</label>
              <md-input
                id="txtDeadline"
                v-model="item.details.deadline"
                name="deadline"
                type="text"
                disabled
                placeholder="Prazo de execução"
              />
            </md-input-container>
          </md-layout>
          <md-layout
            v-if="item.details.minimumVolume?.trim()"
            md-flex="15"
          >
            <md-input-container id="minimumVolume">
              <label>Volume Mínimo</label>
              <md-input
                id="txtMinimumVolume"
                v-model="item.details.minimumVolume"
                name="minimumVolume"
                type="text"
                disabled
                placeholder="Volume Mínimo"
              />
            </md-input-container>
          </md-layout>
        </md-layout>

        <md-layout
          md-flex="100"
          class="exam-paternity__details"
        >
          <h2 class="title-main form-title">
            Participantes do exame de maternidade
          </h2>
          <div class="exam-paternity__items">
            <md-layout
              v-for="(participant, index) in maternity_participants"
              :key="index"
              :md-gutter="24"
              :md-flex="100"
            >
              <md-layout md-flex="15">
                <md-input-container
                  class="md-advanced-select md-input-placeholder"
                  :class="{
                    'md-has-value': participant.relationshipCombo,
                    'md-input-invalid': errors.has('relationship' + index),
                    'md-input-disabled': participant.disabled
                  }"
                >
                  <label>Participante *</label>
                  <advanced-select
                    :id="'cboNewPatExamParticipants_' + index"
                    v-model="participant.relationshipCombo"
                    v-validate="'required'"
                    :name="'relationship' + index"
                    placeholder=""
                    :options="participantsRelationshipOptions"
                    data-vv-validate-on="none"
                    :disabled="participant.disabled"
                    @onChange="selectGender(index)"
                  />
                  <span class="md-error">Obrigatório</span>
                </md-input-container>
              </md-layout>
              <md-layout
                md-flex="35"
                md-flex-medium="35"
                md-flex-large="35"
              >
                <md-input-container
                  id="participantName"
                  :class="{ 'md-input-invalid': errors.has('participantName' + index) }"
                >
                  <label>Nome do participante *</label>
                  <md-input
                    :id="'txtNewPatExamParticipants_' + index"
                    v-model="participant.name"
                    v-validate="'required'"
                    :name="'participantName' + index"
                    type="text"
                    maxlength="100"
                    placeholder="Nome do participante *"
                    data-vv-validate-on="none"
                    @keydown.enter.native="focusNextField('txtNewPatExamBirthdate_' + index)"
                  />
                  <span class="md-error">Obrigatório</span>
                </md-input-container>
              </md-layout>

              <md-layout md-flex="25">
                <md-input-container
                  id="patientBirthDate"
                  :class="{ 'md-input-invalid': errors.has('birthDate' + index) }"
                >
                  <label>Data de nascimento *</label>
                  <md-input
                    :id="'txtNewPatExamBirthdate_' + index"
                    v-model="participant.birthdate"
                    v-mask="'##/##/####'"
                    v-validate="'required|check_date_format:DD/MM/YYYY|not_future_date|after_date:31/12/1899'"
                    :name="'birthDate' + index"
                    placeholder="Data de nascimento *"
                    maxlength="10"
                    type="text"
                    data-vv-validate-on="none"
                    @keydown.enter.native="focusNextFieldDropdownSexo('gender', index)"
                  />
                  <span
                    v-if="errors.firstByRule('birthDate' + index, 'required')"
                    class="md-error"
                  >Obrigatório</span>
                  <span
                    v-else-if="errors.firstByRule('birthDate' + index, 'not_future_date')"
                    class="md-error"
                  >
                    Data não pode ser maior que a atual
                  </span>
                  <span
                    v-else-if="errors.firstByRule('birthDate' + index, 'after_date')"
                    class="md-error"
                  >
                    Ano deve ser maior que 1899
                  </span>
                  <span
                    v-else-if="errors.firstByRule('birthDate' + index, 'check_date_format')"
                    class="md-error"
                  >
                    Valor inválido
                  </span>
                </md-input-container>
              </md-layout>
              <md-layout md-flex="15">
                <md-input-container
                  id="gender"
                  class="md-advanced-select md-input-placeholder"
                  :class="{
                    'md-has-value': participant.genderCombo,
                    'md-input-invalid': errors.has('gender' + index),
                    'md-input-disabled': isGenderDisabled(participant)
                  }"
                >
                  <label>Sexo *</label>
                  <advanced-select
                    :id="'cboNewPatExamGender_' + index"
                    v-model="participant.genderCombo"
                    v-validate="'required'"
                    :name="'gender' + index"
                    placeholder=""
                    :options="genderOptions"
                    data-vv-validate-on="none"
                    :disabled="isGenderDisabled(participant)"
                    @enter="focusNextField('txtNewPatExamIdentification_' + index)"
                  />
                  <span class="md-error">Obrigatório</span>
                </md-input-container>
              </md-layout>
              <md-layout md-flex="10">
                <md-input-container
                  class="number-tag-combo"
                  :class="{ 'md-input-invalid': errors.has('numberTag' + index) }"
                >
                  <label>Qtd.<br>Etiquetas *</label>
                  <md-input
                    :id="'txtNewPatExamTagQuantity_' + index"
                    v-model="participant.number_tag_print"
                    v-mask="'#'"
                    v-validate="'required|min_value:1|max_value:9|digits:1'"
                    :name="'numberTag' + index"
                    type="number"
                    min="1"
                    max="9"
                    data-vv-validate-on="none"
                    @keydown.enter.native="focusNextField('identificatorNameDefault')"
                  />
                  <span
                    v-if="errors.firstByRule('numberTag' + index, 'required')"
                    class="md-error"
                  >Obrigatório</span>
                  <span
                    v-else-if="
                      errors.firstByRule('numberTag' + index, 'min_value') ||
                        errors.firstByRule('numberTag' + index, 'max_value') ||
                        errors.firstByRule('numberTag' + index, 'digits')
                    "
                    class="md-error"
                  >Valor inválido</span>
                </md-input-container>
              </md-layout>
            </md-layout>
            <md-layout
              :md-gutter="24"
              md-flex="100"
            >
              <md-layout
                id="identificator"
                md-flex="50"
              >
                <md-input-container :class="{ 'md-input-invalid': errors.has('identificatorNameDefault') }">
                  <label>Nome completo do identificador *</label>
                  <md-input
                    id="identificatorNameDefault"
                    v-model="identificatorNameDefault"
                    v-validate="'required'"
                    name="identificatorNameDefault"
                    placeholder="Nome completo do identificador *"
                    type="text"
                    maxlength="20"
                    data-vv-validate-on="none"
                    @keydown.enter.native="focusNextField('btnNewSubmitExam')"
                  />
                  <span class="md-error">Obrigatório</span>
                </md-input-container>
              </md-layout>
            </md-layout>
          </div>
        </md-layout>

        <md-layout
          md-flex="100"
          md-align="end"
          class="exam-paternity__footer"
        >
          <md-layout md-flex="33">
            <md-button
              id="btnNewSubmitExam"
              class="btn btn-primary orders-new__patient__submit-button submit-button"
              @click="validateBeforeSubmit"
              @keydown.enter.native="validateBeforeSubmit"
            >
              OK
            </md-button>
          </md-layout>
        </md-layout>

        <md-button
          v-if="!disableDeletion"
          class="md-icon-button card-form__delete-button"
          @click="deleteOrderExams(item)"
        >
          <md-icon class="card-form__delete-button-icon icon-delete-alt" />
          <md-tooltip
            md-delay="400"
            md-direction="top"
          >
            Excluir exame
          </md-tooltip>
        </md-button>
      </div>

      <md-layout
        slot="collapsed"
        class="collapsed-container card-form--collapsed"
        :md-gutter="24"
        md-flex="100"
        @click.native="editExam(item)"
      >
        <md-layout
          class="collapsed__item"
          md-flex="15"
        >
          <div class="md-input-container md-theme-default">
            <h3>Código do Exame</h3>
            <p :title="item.details.code">
              {{ item.details.code }}
            </p>
          </div>
        </md-layout>
        <md-layout
          class="collapsed__item"
          md-flex="35"
        >
          <div class="md-input-container md-theme-default">
            <h3>Nome do Exame</h3>
            <p :title="item.details.name">
              {{ item.details.name }}
            </p>
          </div>
        </md-layout>
        <md-layout
          class="collapsed__item"
          md-flex="20"
        >
          <div class="md-input-container md-theme-default">
            <h3>Material</h3>
            <p
              class="material"
              :title="materialName"
            >
              {{ materialId }} - {{ materialName }}
            </p>
          </div>
        </md-layout>
        <md-layout
          class="collapsed__item"
          md-flex="10"
        >
          <div class="md-input-container md-theme-default">
            <h3 class="dont-wrap">
              Qtd. Amostras
            </h3>
            <p>{{ amount }}</p>
          </div>
        </md-layout>
        <md-layout
          class="collapsed__item"
          md-flex="15"
        >
          <div class="md-input-container md-theme-default">
            <h3>Acondicionamento</h3>
            <p
              class="md20"
              :title="conditioning"
            >
              {{ conditioning }}
            </p>
          </div>
        </md-layout>
        <p
          id="btnNewEditExam"
          class="collapsed__list__item__edit-button"
          :class="{ 'collapsed__list__item__delete-button': disableDeletion }"
          @click="editExam(item)"
        >
          <md-icon class="collapsed__list__item__edit-button__icon icon-edit-alt" />
          <md-tooltip
            md-delay="400"
            md-direction="top"
          >
            Editar exame
          </md-tooltip>
        </p>
        <p
          v-if="!disableDeletion"
          id="btnNewDeleteExam"
          class="collapsed__list__item__delete-button"
          @click.prevent="deleteOrderExams(item)"
        >
          <md-icon class="card-form__delete-button-icon icon-delete-alt" />
          <md-tooltip
            md-delay="400"
            md-direction="top"
          >
            Excluir exame
          </md-tooltip>
        </p>
      </md-layout>
    </card-form>
  </div>
</template>

<script>
import Vue from 'vue'

import strings from '@/strings'

import mixin from '@/components/Exams/Create/examMixin'
import ExamsModalAlert from '../ExamsModalAlert'

export default {
  name: 'MaternityExam',
  components: {
    ExamsModalAlert
  },
  mixins: [mixin],
  data: () => {
    return {
      genderOptions: strings.genders,
      participantsRelationshipOptions: strings.participantsRelationship,
      collector_name: '',
      judge_name: '',
      maternity_participants: [],
      identificatorNameDefault: ''
    }
  },
  computed: {
    material: {
      get: function () {
        if (!this.item || !this.item.details || !this.item.details.materials || !this.item.sample.material) {
          return null
        }

        // Busca na lista de materiais disponiveis
        // aquele que possui o mesmo id do item da store
        for (let i = 0; i < this.item.details.materials.length; i++) {
          let element = this.item.details.materials[i]
          if (element.id === this.item.sample.material) {
            return element
          }
        }
      },
      set: function (value) {
        if (JSON.stringify(value).length > 2) {
          this.updateExam({
            raw: this.item,
            id: this.item.id,
            material: !value ? 0 : value.id,
            amount: this.maternity_participants.length,
            notes: this.item.notes
          })
        }
      }
    },
    amount: {
      get: function () {
        if (!this.item || !this.item.sample) {
          return 0
        }
        return this.maternity_participants.length
      }
    },
    notes: {
      get: function () {
        if (!this.item) {
          return ''
        }
        return this.item.notes
      },
      set: function (value) {
        if (!this.item || !this.item.sample) {
          return
        }

        this.updateExam({
          raw: this.item,
          id: this.item.id,
          material: this.item.sample.material,
          amount: this.item.sample.amount,
          notes: value
        })
      }
    }
  },
  watch: {
    identificatorNameDefault: function (newValue) {
      if ((this.item.details.code === 'PATDUO') | (this.item.details.code === 'PAT')) {
        if (newValue.length === 25) {
          this.identificatorNameLengthMessage = true
        } else {
          this.identificatorNameLengthMessage = false
        }
      }
    }
  },
  mounted() {
    if (this.item.details.code === 'PATDUO') {
      this.maternity_participants.push(
        this.newParticipant(0, true),
        // alterar para suposta mãe removendo linha seguinte
        // this.newParticipant())
        this.newParticipant(2, true)
      )
    } else if (this.item.details.code === 'PAT') {
      this.maternity_participants.push(
        this.newParticipant(0, true),
        this.newParticipant(1, true),
        this.newParticipant(2, true)
      )
    }
    this.maternity_participants.forEach((element, index) => {
      this.selectGender(index)
    })
    this.materialOptions = this.item.details.materials.map(function (item) {
      return { label: item.name, value: item.name }
    })

    // edit
    if (this.$route.params.orderid && this.item.details.maternity_participants) {
      this.judge_name = this.item.details.judge_name ? this.item.details.judge_name : ''
      this.collector_name = this.item.details.collector_name ? this.item.details.collector_name : ''
      if (this.item.details.maternity_participants.length > 0) {
        this.maternity_participants = this.item.details.maternity_participants
        this.identificatorNameDefault = this.item.details.maternity_participants[0].identification_name
      }
    }

    this.analyticsSuccessInsertingExam(this.item.details.id)
    let self = this
    Vue.nextTick(function () {
      self.validateOnMount()
    })
  },
  methods: {
    beforeSucessAddNewExam() {
      this.maternity_participants.forEach(participant => {
        participant.identification_name = this.identificatorNameDefault
      })

      this.updateExam({
        raw: this.item,
        id: this.item.id,
        material: this.item.sample.material,
        amount: this.maternity_participants.length,
        notes: this.item.notes,
        collector_name: this.collector_name,
        judge_name: this.judge_name,
        maternity_participants: this.maternity_participants
      })
    },
    newParticipant(indexString, disabled) {
      return {
        name: '',
        birthdate: '',
        genderCombo: null,
        relationshipCombo: indexString === null ? null : strings.participantsRelationship[indexString],
        identification_name: '',
        number_tag_print: '1',
        disabled: disabled
      }
    },
    selectGender(index) {
      this.maternity_participants[index].genderCombo = this.maternity_participants[index].relationshipCombo
        ? this.genderOptions.filter(
          gender => gender.value === this.maternity_participants[index].relationshipCombo.gender
        )[0]
        : null
    },
    isGenderDisabled: participant => {
      return !(participant.relationshipCombo && participant.relationshipCombo.label === 'Filho')
    },
    focusNextField(id) {
      document.getElementById(id).focus()
    },
    focusNextFieldDropdownSexo(id, index) {
      document.getElementById(id).focus()
      document.getElementById('cboNewPatExamGender_' + index).firstElementChild.focus()
    }
  }
}
</script>

<style lang="scss">
@import '../../../../static/stylesheets/mixins';
@import '../../../../static/stylesheets/components/orders/common-exam';

.exam {
  &__container {
    .exam-maternity {
      &__details {
        display: flex;
        flex-direction: column;
        padding: 0 12px;
        margin: 40px 0 0;

        h2:not(.title-main) {
          border-bottom: 1px solid #c2c2c2;
          padding-bottom: 8px;
          margin: 0;
        }
      }

      &__items {
        display: table;
        width: 100%;
        padding: 19px 0 0;
        margin: 0;

        .advanced-select {
          &__container {
            .multiselect {
              &__single {
                font-size: 14px;
              }

              &--disabled,
              &__select {
                background: none;
              }

              &__option--disabled {
                display: none;
              }
            }
          }
        }

        & > .md-layout {
          .md-layout {
            .md-input-container {
              margin: 0 0 35px;

              input,
              textarea {
                font-size: 14px;

                &::placeholder,
                &::-webkit-input-placeholder {
                  font-size: 14px;
                }
              }

              &.md-input-placeholder {
                &.md-advanced-select {
                  &:not(.md-has-value) {
                    label {
                      font-size: 14px;
                    }
                  }
                }
              }

              &.md-input-disabled {
                .advanced-select {
                  &__container {
                    cursor: not-allowed;
                  }
                }
              }

              &.number-tag-combo {
                & > label {
                  margin-top: -12px;
                  line-height: 14px;
                  white-space: nowrap;
                  color: #303030;
                  font-size: 14px;
                }
                &.md-input-focused,
                &.md-has-value {
                  & > label {
                    color: #858585;
                    font-size: 12px;
                  }
                }
              }

              &.md-input-invalid {
                .md-error {
                  line-height: 16px;
                }
              }
            }
          }
        }
      }

      &__footer {
        margin-bottom: 17px;
      }
    }

    &.maternity-exam {
      @media all and (-ms-high-contrast: none) {
        .md-layout {
          .md-layout {
            display: table;
          }

          .md-flex-15 {
            min-width: 15%;
            flex: 0 1 15%;
          }

          .md-flex-20 {
            min-width: 20%;
            flex: 0 1 20%;
          }

          .md-flex-35 {
            min-width: 35%;
            flex: 0 1 35%;
          }
        }

        .exam-paternity__items {
          & > .md-layout {
            display: flex;
          }
        }
      }

      .multiselect__content-wrapper {
        overflow: hidden;
      }
    }

    #identificator {
      max-width: 50%;
    }

    .title-card {
      margin-bottom: 24px;
      padding: 0 12px;
    }

    .exam-item__details-anchor {
      display: flex;
      align-items: center;
      height: 20px;

      .exam-item__details-icon {
        height: 20px;
        min-height: 20px;
        width: 20px;
        min-width: 20px;
        margin-right: 6px;
      }

      .exam-item__details-icon,
      a {
        color: #7f1a54 !important;
      }
    }
  }
}

input[type='number'] {
  -moz-appearance: textfield;

  &:focus,
  &:hover {
    -moz-appearance: none;
  }
}
</style>
